import Vue from 'vue'

import { BootstrapVue, BootstrapVueIcons, BadgePlugin, BFormGroup} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
//import '../css/customized-bootstrap.scss'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import '../css/Site.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(BadgePlugin)
Vue.component('b-form-group', BFormGroup)

Vue.config.productionTip = true

//This is for debugging in Chrome.
Vue.config.devtools = true
import '../types/string.extensions'
import '../types/date.extensions'
//Need this for the *Date* to parse correctly from axios response.
require('json.date-extensions/json.date-extensions')
JSON['useDateParser']();
JSON['parseMsAjaxDate'] = true;

//Shared Folder
Vue.component('popup', require('./components/shared/popup.vue').default);
Vue.component('alert-popup', require('./components/shared/alertPopup.vue').default);
//Vue.component('oldmedpass-alert-popup', require('./components/shared/OldMedpassAlertPopup.vue').default);
Vue.component('add-form-component', require('./components/shared/AddFormPopup.vue').default);
Vue.component('sso-popup', require('./components/shared/SSOPopup.vue').default);
Vue.component('gpi-subs-popup', require('./components/shared/GPISubsPopup.vue').default);
Vue.component('clinical-summary-queue-viewer', require('./components/shared/ClinicalSummaryViewer.vue').default);
Vue.component('clinical-report-popup', require('./components/shared/EHRClinicalReportPopup.vue').default);
Vue.component('delete-reason-popup', require('./components/shared/DeleteReasonPopup.vue').default);

// Vue.component('dropdown', require('./components/shared/Dropdown.vue').default);

Vue.component('collectEpcsSerialNumber', require('./components/CollectEPCSSerialNumber.vue').default);
Vue.component('family-history-popup', require('./components/FamilyHistoryPopup.vue').default);
Vue.component('facility-documents-popup', require('./components/FacilityDocumentsPopup.vue').default);
Vue.component('partial-forms-popup', require('./components/PartialFormsPopup.vue').default);
Vue.component('document-treeview-vue-component', require('./components/DocumentTreeview.vue').default);
Vue.component('tree-item', require('./components/DocumentTreeViewItem.vue').default);
Vue.component('patient-documentation-component', require('./components/PatientDocumentationPopup.vue').default);
Vue.component('dental-session-vue-component', require('./components/Dental/DentalSession.vue').default);
Vue.component('consult-calendar-vue-component', require('./components/ConsultCalendar.vue').default);
Vue.component('region-dashboard-vue-component', require('./components/RegionDashboardProfile.vue').default);
Vue.component('consult-claim-popup', require('./components/shared/ConsultClaimPopup.vue').default);
Vue.component('launch-patient-pass-popup', require('./components/LaunchPatientPassPopup.vue').default);
Vue.component('gpi-substitution-popup', require('./components/GPISubstitutionPopup.vue').default);
//Vue.component('consult-dc-popup', require('./components/ConsultDCPopup.vue').default);
//Vue.component('image-editor-vue-component', require('./components/ImageEditor.vue').default);
//Vue.component('show-pdf-viewer', require('./components/SuperSimplePdfViewer.vue').default);

// EHR Dashboard Components.
Vue.component('dashboard-main-vue-component', require('./components/EHRDashboard/DashboardMain.vue').default);

// Tasking Components exposed to Sapphire.
Vue.component('save-task-filter-popup-component', require('./components/Tasking/TaskFilterSavePopup.vue').default);


Vue.component('sapphire-playground-app', require('./components/PlaygroundApp.vue').default);


// Vue The Mask:  Used for masking inputs.
// import VueTheMask from 'vue-the-mask'
// Vue.use(VueTheMask)

//Sweet Alerts
// Include the Dark theme -->
import '@sweetalert2/theme-dark/dark.css'

import VueSweetalert2 from 'vue-sweetalert2';
const options = {
    customClass: {
        container: 'swal2-container-vue',
        content: 'swal2-content-vue',
        popup: 'swal2-popup-vue',
        footer: 'swal2-footer-vue',
        // title: 'swal2-title-vue',
        // cancelButton: 'swal-button-vue',
        // confirmButton: 'swal-button-vue',
        // closeButton: 'swal-button-vue',
    },
  };

Vue.use(VueSweetalert2, options);

//Import Vue-Select
import "vue-multiselect/dist/vue-multiselect.min.css"
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect);

import { ValidationProvider, ValidationObserver } from "vee-validate";
// Register it globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

//***  THIS IS FOR TESTING IN VUE ONLY!!!!! ***
// import App from './components/PlaygroundApp.vue';

// new Vue({
//   render: (h) => h(App),
// }).$mount('#app');

declare global {
  interface Window { Vue: any; }
}


window.Vue = Vue;
